// extracted by mini-css-extract-plugin
module.exports = {"photo":"style_photo__2UYNJ","hasImage":"style_hasImage__1jFph","spinning":"style_spinning__249jW"};